import { createPortal } from 'react-dom';
import { OPINION_DECISION } from '../../constants/opinion.constants';
import {
	Actions,
	CloseButton,
	DisabledMessage,
	HintMessage,
	Modal,
	ModalTitle,
	Overlay,
	PrimaryButton,
	SecondaryButton,
	Textarea,
} from './ChatFeedbackModal.styles';

const ChatFeedbackModal = ({
	activeDecision,
	text,
	setText,
	cancelFeedback,
	skipFeedback,
	submitFeedback,
	isSubmitDisabled,
	isSubmitting,
	t,
}) => {
	if (!activeDecision) {
		return null;
	}

	const isHandDown = activeDecision === OPINION_DECISION.HAND_DOWN;

	return createPortal(
		<Overlay onClick={cancelFeedback} role="presentation">
			<Modal
				role="dialog"
				aria-modal="true"
				aria-labelledby="chat-feedback-title"
				onClick={(event) => event.stopPropagation()}
			>
				<CloseButton
					type="button"
					onClick={cancelFeedback}
					aria-label={t.galleryClose}
				>
					×
				</CloseButton>
				<ModalTitle id="chat-feedback-title">
					{isHandDown ? t.feedbackDislikeTitle : t.feedbackLikeTitle}
				</ModalTitle>
				<Textarea
					placeholder={
						isHandDown
							? t.feedbackDislikePlaceholder
							: t.feedbackOptionalPlaceholder
					}
					value={text}
					onChange={(event) => setText(event.target.value)}
					disabled={isSubmitting}
				/>
				<Actions>
					<SecondaryButton
						type="button"
						onClick={skipFeedback}
						disabled={isSubmitting}
					>
						{t.feedbackSkip}
					</SecondaryButton>
					<PrimaryButton
						type="button"
						onClick={submitFeedback}
						disabled={isSubmitDisabled || isSubmitting}
					>
						{isSubmitting ? t.feedbackSending : t.feedbackSubmit}
					</PrimaryButton>
				</Actions>
				{isSubmitDisabled ? (
					<DisabledMessage>{t.feedbackMinLengthHint}</DisabledMessage>
				) : (
					<HintMessage>{t.feedbackHint}</HintMessage>
				)}
			</Modal>
		</Overlay>,
		document.body,
	);
};

export default ChatFeedbackModal;
